<template>
  <portal to="subPageControls">
<!--    <div class="sub-page-controls" :class="setClassModifiers('sub-page-controls&#45;&#45;')">-->
    <div class="sub-page-controls" :class="setClassModifiers('sub-page-controls--')" slot-scope="props" :style="{ opacity: props.opacity }">
      <slot></slot>
    </div>
  </portal>
</template>
<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  mixins: [setClassModifiers],

  props: {
    noPadding: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      narrow: false,

      minOpacity: 0,
      maxOpacity: 1,
      opacity: 1
    }
  },

  methods: {
    getOpacity (scrollTop) {
      const opacity = this.maxOpacity - ((this.maxOpacity - this.minOpacity) / 100 * scrollTop)
      if (opacity < this.minOpacity) {
        this.opacity = this.minOpacity
      } else {
        this.opacity = opacity
      }

      return this.opacity
    }
  },

  mounted () {
    this.narrow = this.$route.name !== 'dashboard'
  }
}
</script>

<style lang="scss">
  .sub-page-controls {
    max-width: 120rem;
    margin-left: auto;
    margin-right: auto;

    padding-top: $default-spacing-mobile;
    padding-bottom: $default-spacing-mobile;
    /*padding-top: $default-spacing-mobile;
    padding-right: 0;*/

    & > * {
      padding-left: $default-spacing-mobile;
      padding-right: $default-spacing-mobile;
    }

    @include respond(tab-port) {
      padding-top: $default-spacing;
      padding-bottom: $default-spacing;

      & > * {
        padding-left: $default-spacing;
        padding-right: $default-spacing;
      }
    }

    /*&--narrow {*/
    /*  max-width: 78rem;*/
    /*}*/
  }
</style>
